import { toPermission } from '../converters/permissionsConverter';

export const hasObjPermission = (permission, userPermissions) =>
  !!userPermissions.find(
    (p) =>
      p.domain === permission.domain &&
      p.subdomain === permission.subdomain &&
      p.action === permission.action &&
      p.decision === permission.decision
  ) ||
  (!!userPermissions.find(
    (p) =>
      p.domain === permission.domain &&
      p.subdomain === undefined &&
      p.action === permission.action &&
      p.decision !== 'DENY'
  ) &&
    !userPermissions.find(
      (p) =>
        p.domain === permission.domain &&
        p.subdomain === permission.subdomain &&
        p.action === permission.action &&
        p.decision === 'DENY'
    ));

export const hasPermission = (permission, userPermissions = []) =>
  hasObjPermission(toPermission(permission), [...userPermissions].map(toPermission));

export const hasPermissions = (permissions = [], userPermissions = []) =>
  permissions.every((permission) => hasPermission(permission, userPermissions));
